import React, { useEffect } from 'react';
import Header from '../components/Header';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import { initSEO } from '../seo';

const ContactUsPage = () => {
  useEffect(() => {
    initSEO('contact');
  }, []);

  return (
    <>
      <Header />
      <ContactUs />
      <Footer />
    </>
  );
};

export default ContactUsPage;
